import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { BillingSummaryDto } from '@repo/shared-types';
import { apiFetch } from '../lib/api';

export const BILLING_SUMMARY_QUERY_KEY = ['billing', 'summary'] as const;

/** `GET /api/billing/summary` (spec D7/M5 task-6, live-wired in M6 Task 3) — workspace-level,
 * not per-bot. Both the Billing screen and the BotOverview 80%-usage banner share this one
 * query (React Query dedupes the two callers under the same key). `refetchInterval` is the
 * Billing screen's post-checkout poll (`?upgraded=1` — see `Billing.tsx`); accepts react-
 * query's own function form (receives the live query, not this hook's return value — avoids
 * a circular "the interval depends on the data this call itself produces" dependency) so the
 * poll can stop itself once the plan actually flips. Everyone else leaves it at the default
 * `false` (no polling). */
export function useBillingSummary(
  opts: { refetchInterval?: UseQueryOptions<BillingSummaryDto>['refetchInterval'] } = {},
) {
  return useQuery({
    queryKey: BILLING_SUMMARY_QUERY_KEY,
    queryFn: () => apiFetch<BillingSummaryDto>('/api/billing/summary'),
    staleTime: 30_000,
    refetchInterval: opts.refetchInterval ?? false,
  });
}
